import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import ContactForm from '../components/ContactForm';
import MetaTags from '../common-components/MetaTags';

class ContactUsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    //  document.title = "Contact Us - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 100); // Simulate a 3-second loading delay
  }


  render() {
    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        // { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Contact', href: '#', isCurrentPage: true },
      ];

    return <>
    <MetaTags
      title="Contact - Learn Quran Easily"
      description="Get in touch with Learn Quran Easily for inquiries, support, and feedback. We are here to help you on your Quran learning journey."
      keywords="Contact Learn Quran Easily, Support, Inquiries, Feedback, Quran Learning Help"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/contact"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Contact" breadcrumbs={breadcrumbs} />
          <ContactForm />
        </>}
    </>
  }
}

export default ContactUsPage;
